/**
 * @generated SignedSource<<3636925835f3d7de17cd8bdac62f336a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersFilterTypeChoices = "PN" | "PT" | "%future added value";
export type DeleteFilterInput = {
  clientMutationId?: string | null;
  filterId: string;
};
export type DrawerFilters_DeleteFilter_Mutation$variables = {
  input: DeleteFilterInput;
};
export type DrawerFilters_DeleteFilter_Mutation$data = {
  readonly deleteFilter: {
    readonly study: {
      readonly filters: ReadonlyArray<{
        readonly filters: any;
        readonly id: string;
        readonly name: string;
        readonly study: {
          readonly id: string;
        } | null;
        readonly type: ScreenersFilterTypeChoices;
        readonly user: {
          readonly id: string;
        } | null;
      }>;
      readonly id: string;
    } | null;
    readonly tenant: {
      readonly filters: ReadonlyArray<{
        readonly filters: any;
        readonly id: string;
        readonly name: string;
        readonly study: {
          readonly id: string;
        } | null;
        readonly type: ScreenersFilterTypeChoices;
        readonly user: {
          readonly id: string;
        } | null;
      }>;
      readonly id: string;
    };
  } | null;
};
export type DrawerFilters_DeleteFilter_Mutation = {
  response: DrawerFilters_DeleteFilter_Mutation$data;
  variables: DrawerFilters_DeleteFilter_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "FilterNode",
    "kind": "LinkedField",
    "name": "filters",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filters",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StudyNode",
        "kind": "LinkedField",
        "name": "study",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFilterPayload",
    "kind": "LinkedField",
    "name": "deleteFilter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TenantNode",
        "kind": "LinkedField",
        "name": "tenant",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StudyNode",
        "kind": "LinkedField",
        "name": "study",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DrawerFilters_DeleteFilter_Mutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DrawerFilters_DeleteFilter_Mutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "f44fef5f40fe5faa7279aa62fe3e6bfb",
    "id": null,
    "metadata": {},
    "name": "DrawerFilters_DeleteFilter_Mutation",
    "operationKind": "mutation",
    "text": "mutation DrawerFilters_DeleteFilter_Mutation(\n  $input: DeleteFilterInput!\n) {\n  deleteFilter(input: $input) {\n    tenant {\n      id\n      filters {\n        id\n        filters\n        name\n        study {\n          id\n        }\n        type\n        user {\n          id\n        }\n      }\n    }\n    study {\n      id\n      filters {\n        id\n        filters\n        name\n        study {\n          id\n        }\n        type\n        user {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2966494309cf945e9fe4a9d8301918f";

export default node;
